// extracted by mini-css-extract-plugin
var _1 = "Hero__Hero___e4JcK";
var _2 = "Hero__footer___r9c8m";
var _3 = "Hero__main___cjKMx";
var _4 = "Hero__subtitle___qeeHI";
var _5 = "Hero__title___ZTWdt";
var _6 = "Hero__wiggle___WnuY9";
export { _1 as "Hero", _2 as "footer", _3 as "main", _4 as "subtitle", _5 as "title", _6 as "wiggle" }
